/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_ListInputs */



/**
* | output |
* | --- |
* | "New List" |
*
* @param {New_ListInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_list = /** @type {((inputs?: New_ListInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_ListInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nouvelle liste")
	if (locale === "de") return /** @type {LocalizedString} */ ("Neue Liste")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nuovo elenco")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Новый список")
	if (locale === "es") return /** @type {LocalizedString} */ ("Nueva lista")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("新列表")
	if (locale === "ja") return /** @type {LocalizedString} */ ("新しいリスト")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नई सूची")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nova lista")
	return /** @type {LocalizedString} */ ("New List")
});